<template>
  <div class="addbidOrder">
    <div class="tabWrap">
      <el-tabs v-model="activeName">
        <el-tab-pane label="基本信息" name="first" class="firstTab">
          <div class="screenPanel">
            <el-form
              ref="ruleForm"
              :model="dateForm"
              label-width="150px"
              :inline="true"
              :rules="rules"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item label="项目名称" prop="projectId">
                    <el-select
                      v-model="dateForm.projectId"
                      placeholder="请选择"
                      clearable
                      filterable
                      @change="changeProject"
                    >
                      <el-option
                        v-for="item in projectIdList"
                        :key="item.projectId"
                        :label="item.projectName"
                        :value="item.projectId"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="采购文件事项" prop="bidPlanItem">
                    <el-select
                      v-model="dateForm.bidPlanItem"
                      placeholder="请选择"
                      clearable
                      filterable
                      @change="changeProjectSubName"
                    >
                      <el-option
                        v-for="item in projectsubList"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="采购计划编号" prop="bidPlanId">
                    <el-select
                      v-model="dateForm.bidPlanId"
                      placeholder="请选择"
                      clearable
                      filterable
                      @change="changebidPlanCode"
                    >
                      <el-option
                        v-for="item in bidPlanCodeList"
                        :key="item.id"
                        :label="item.bidPlanCode"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="项目类别">
                    <el-input
                      v-model="dateForm.projectType"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="采购金额">
                    <el-input
                      v-model="dateForm.estimatePrice"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="采购方式：" prop="bidPlanMethodKey">
                     <el-select
                      v-model="dateForm.bidPlanMethodKey"
                      filterable
                      default-first-option
                      placeholder="请选择"
                      @change="changeType"
                    >
                      <el-option
                        v-for="item in typeOption"
                        :key="item.label"
                        :label="item.value"
                        :value="item.label"
                      ></el-option>
                    </el-select>
                    <!-- <el-input
                      v-model="dateForm.bidPlanMethodValue"
                      readonly
                    ></el-input> -->
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="是否已取得决策依据">
                    <el-select
                      v-model="dateForm.isDecisionBase"
                      placeholder="请选择"
                    >
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="提报单位/部门" prop="commitDeptId">
                    <el-input
                      v-model="dateForm.commitDeptName"
                      placeholder="请选择填报部门"
                      readonly
                      style="width: 79%"
                    ></el-input>
                    <el-button
                      @click="selectAttendDepart"
                      type="primary"
                      style="min-width: 60px"
                      >选择</el-button
                    >
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="联签单类别" prop="commitDeptId">
                    <el-select
                      v-model="dateForm.signatureType"
                      default-first-option
                      placeholder="请选择"
                    >
                      <el-option
                        :label="item.label"
                        :value="item.value"
                        v-for="(item, index) in options"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="提报单位负责人"
                    prop="commitResponseUserName"
                  >
                    <el-input
                      v-model="dateForm.commitResponseUserName"
                      placeholder="请选择提报单位负责人"
                      readonly
                      style="width: 79%"
                    ></el-input>
                    <el-button
                      @click="selectSubmitPerson('commitResponseUserName')"
                      type="primary"
                      style="min-width: 60px"
                      >选择</el-button
                    >
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="经办人" prop="handlingUserName">
                    <el-input
                      v-model="dateForm.handlingUserName"
                      placeholder="请选择经办人"
                      readonly
                      style="width: 79%"
                    ></el-input>
                    <el-button
                      @click="selectSubmitPerson('handlingUserName')"
                      type="primary"
                      style="min-width: 60px"
                      >选择</el-button
                    >
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="项目情况" prop="projectState">
                    <el-input
                      type="textarea"
                      :rows="4"
                      maxlength="5000"
                      show-word-limit
                      placeholder="请输入内容"
                      v-model="dateForm.projectState"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="附件"
          name="fourth"
          style="text-align: left"
          class="firstTab"
        >
          <upLoadFileDialog
            :itemVOs="dateForm.attachmentList"
            @saveUpdateFile="saveUpdateFile"
          ></upLoadFileDialog>
        </el-tab-pane>
        <el-tab-pane
          label="审批流程"
          name="fivth"
          style="text-align: left; width: 90%; margin-top: 20px"
        >
          <addApproveLine
            :addoredit="editFlag"
            :itemId="bidOrderId || 0"
            @saveApproveLine="saveApproveLine"
            @saveApproveType="saveApproveType"
            :approveType="approveType"
            :approveClass="approveClass"
            :subApproveType="dateForm.approveTemplateType"
            :subApproveName="dateForm.approveTemplateName || ''"
          ></addApproveLine>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="bottomBtn">
      <el-button type="primary" @click="savebidplanInfo(0)">暂 存</el-button>
      <el-button type="primary" @click="savebidplanInfo(2)">提 交</el-button>
      <el-button type="info" @click="close">取 消</el-button>
    </div>
    <!--选择部门弹窗 -->
    <select-dialog
      :visible="selectDialogVisible"
      @close="selectDialogClose"
      title="选择"
      v-bind="selectDialogOptions"
    />
  </div>
</template>

<script>
import {
  getprojectGeneral,
  saveBidOrder, //新增一条采购文件
  updateBidOrder, //更新一条采购文件
  getBidOrderdetail, //获取一条采购文件信息
  getProjects, //获取采购文件里的项目
  getBidPlanNos, //根据项目部获取采购文件下拉框数据
  getSubProjects, //根据采购计划编号获取工程分项下拉框数据
   getBidTypeDic, //获取一级数据字典接口
} from "@/services/bidServices";
import { getAllProjectPassListService } from "@/services/engineering";
import { saveApproveFun,updateApproveFun } from "@/page/approveComponents/approve";
import addApproveLine from "@/page/approveComponents/NewApproveLine"; //新增审批流程
import upLoadFileDialog from "@/components/upLoadFileDialog"; //上传附件
import SelectDialog from "@/components/SelectDialog";

export default {
  name: "addbidOrder",
  components: {
    upLoadFileDialog, //上传附件
    addApproveLine,
    SelectDialog,
  },
  data() {
    return {
      activeName: "first", //活动tab页
      approveType: "bidmanager", //审批流类型
      approveClass: "BID_JOIN_SIGNATURE",
      flag:false,  //是否保存过审批流
      editFlag: false, //false：新建 true：编辑
      deptIdList: [],
      typeOption: [],
      projectIdList: [], //所属项目下拉框
      bidPlanCodeList: [], //采购计划编号下拉框
      projectsubList: [], //工程分项名称
      bidOrderId: "", //存储id
      selectDialogVisible: false,
      rLoading:null,
      dateForm: {
        id: 0,
        bidPlanId: "", //采购计划编号
        projectId: "", //项目名称
        commitDeptName: "", //提报部门
        signatureType: "", //联签单类别
        commitDeptId: "", //提报部门
        commitResponseUserName: "", //提报部门负责人名字
        commitResponseUserId: "", //提报部门负责人id
        handlingUserName: "", //经办人名字
        handlingUserId: "", //经办人id
        projectState: "", //项目内容
        bidPlanItem: "", //采购文件事项
        attachmentList: [], //采购文件附件
        projectType: "", //项目类别
        bidPlanMethodKey: "", //采购方式字典key
        bidPlanMethodValue: "", //
        isDecisionBase: "0",
        estimatePrice: "", //采购金额
        status: "", //是否暂存标识 0：暂存，2：提交
        remark: "", //备注
        approveTemplateType: "bidorder",
        approveTemplateName: "采购文件审核",
      },
      approveParams: {
        approveProcessDtoList: [], //审批流列表
        approveStatusEnum: "UNDERAPPLY", //初始审批状态，目前只支持READY和UNDERAPPLY,可用值:READY,RECALL,UNDERAPLLY,PASS,REJECT,SHOW_SAVE,SHOW_CREATE,SHOW_SUBMIT
        itemId: 0, //审批对象ID
        itemName: "", //审批对象描述
        projectId: 0, //项目ID
      },
      selectDialogOptions: {
        departOn: true,
        groupOn: true,
        canSelectDepart: false,
        canSelectUser: true,
        canSelectGroup: false,
        maxSelectedItem: 1,
        dataKey: "reportPerson",
        canSelectAll: true,
      },
      options: [
        {
          label: "采前联签单",
          value: "before",
        },
        {
          label: "采后联签单",
          value: "after",
        },
      ],
      planDetailTableData: [],
      rules: {
        bidPlanId: [
          { required: true, message: "请选择采购文件编码", trigger: "change" },
        ],
        projectId: [
          { required: true, message: "请选择项目", trigger: "change" },
          // {
          //   min: 1,
          //   max: 60,
          //   message: "长度在 1 到 60 个字符",
          //   trigger: "blur",
          // },
        ],
        commitResponseUserName: [
          {
            required: true,
            message: "请选择提报单位负责人",
            trigger: "change",
          },
        ],
        bidPlanItem: [
          { required: true, message: "请选择采购文件事项", trigger: "change" },
        ],
        signatureType:[
          { required: true, message: "请选择联签单类别", trigger: "change" },
        ],

        commitDeptName: [
          { required: true, message: "请选择提报部门", trigger: "change" },
        ],

        projectState: [
          { required: true, message: "请填写项目情况", trigger: "blur" },
        ],
         bidPlanMethodKey: [
          { required: true, message: "请选择采购方式", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.dateForm.applyUserName = sessionStorage.getItem("name");
    this.getProject(); //获取项目部下拉框数据
    this.getbidPlanType();
  },
  mounted() {
    let ch = document.documentElement.clientHeight - 60;
    try {
      document.getElementsByClassName("addbidOrder")[0].style.height = ch + "px";
    } catch (error) {
      console.log("-- tableHeight error\n", error);
    }

    window.onresize = () => {
      return (() => {
        let ch1 = document.documentElement.clientHeight - 60;
        document.getElementsByClassName("addbidOrder")[0].style.height =
          ch1 + "px";
      })();
    };
  },
  methods: {
    //获取路由跳转传参
    onActive() {
      this.dateForm.id = this.tabRouteParam?.id ?? 0;
      if (this.dateForm.id) {
        this.editFlag = true;
        //编辑 获取详情
        this.bidOrderId = this.tabRouteParam.id;
        this.getDetail(this.bidOrderId);
      }
    },
    getProject() {
      let param = {
        approveType: "bidSignature",
      };
      getProjects(param)
        .then((res) => {
          if (res.code == "10000000") {
            this.projectIdList = res.data || [];
          }
        })
        .catch(() => {});
    },

    //切换项目名称，获取采购计划编号下拉框数据
    changeProject() {
      let index = this.projectIdList.findIndex(
        (item) => item.projectId === this.dateForm.projectId
      );
      if (index !== -1) {
        this.dateForm.projectName = this.projectIdList[index].projectName;
        // this.dateForm.commitDeptName = this.projectIdList[index].deptName;
        // this.dateForm.commitDeptId = this.projectIdList[index].commitDeptId;
      }
      this.projectsubList = [];
      this.dateForm.bidPlanItem = "";
      this.bidPlanCodeList = [];
      this.dateForm.bidPlanId = "";
      this.dateForm.bidPlanCode = "";
      if (this.dateForm.projectId)
      this.getProjectSubClass();
      this.getAllProject(); //获取项目部对应部门
    },
    changebidPlanCode() {
      if (!this.dateForm.projectId) return;
      if (!this.dateForm.bidPlanId) return;
      let index = this.bidPlanCodeList.findIndex(
        (item) => item.id === this.dateForm.bidPlanId
      );
      if (index !== -1) {
        this.dateForm.bidPlanCode = this.bidPlanCodeList[index].bidPlanCode;
      }
      this.getbidPlanInfo(this.dateForm.bidPlanId);
    },
    changeProjectSubName() {
      if (!this.dateForm.projectId) return;
      // let index = this.projectsubList.findIndex(
      //   (item) => item.projectSubName === this.dateForm.projectSubName
      // );
      // if (index !== -1) {
      //   this.dateForm.bidType = this.projectsubList[index].bidType;
      // }
      this.bidPlanCodeList = [];
      this.dateForm.bidPlanId = "";
      this.dateForm.bidPlanCode = "";
      if (!this.dateForm.bidPlanItem) return;
      this.getbidPlanCodes();
    },
    getbidPlanInfo(id) {
      let param = {};
      param.bidPlanId = id;
      getprojectGeneral(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.dateForm.projectType = res.data.projectType;
            this.dateForm.estimatePrice = res.data.estimatePrice;
            this.dateForm.isDecisionBase = res.data.isDecisionBase.toString();
            this.dateForm.bidPlanMethodKey = res.data.bidPlanMethodKey;
            this.dateForm.bidPlanMethodValue = res.data.bidPlanMethodValue;
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
     //获取采购计划类型下拉框数据
    getbidPlanType() {
      getBidTypeDic().then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.typeOption = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    //切换类型
    changeType() {
      let index = this.typeOption.findIndex(
        (item) => item.label === this.dateForm.bidPlanMethodKey
      );
      if (index !== -1) {
        this.dateForm.bidPlanMethodKey = this.typeOption[index].label;
        this.dateForm.bidPlanMethodValue = this.typeOption[index].value;
      }
    },
    // 提交基本信息
    savebidplanInfo(val) {
      this.$refs["ruleForm"].validate((valid) => {
        //val=true 暂存 false：提交
        if (valid) {
          this.dateForm.status = val;
          this.rLoading = this.openLoading();
          if (val == 0) {
            this.tempSaveContent();
            return;
          }
          if (this.approveParams.approveProcessDtoList.length < 1) {
            this.$alert(" 未选择审批人员", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
          for (
            let i = 0;
            i < this.approveParams.approveProcessDtoList.length;
            i++
          ) {
            delete this.approveParams.approveProcessDtoList[i].type;
            if (
              this.approveParams.approveProcessDtoList[i].approveUserId == "" ||
              null == this.approveParams.approveProcessDtoList[i].approveUserId
            ) {
              // this.$alert(
              //   this.approveParams.approveProcessDtoList[i].jobName +
              //     " 节点未选择审批人员",
              //   "提示",
              //   {
              //     confirmButtonText: "确定",
              //   }
              // );
              this.$alert("未选择审批人员", "提示", {
                confirmButtonText: "确定",
              });
              this.rLoading.close();
              return;
            }
          }
          let msg = "您确定提交吗, 是否继续?";
          this.$confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "info",
          })
            .then(() => {
              this.saveContent();
            })
            .catch(() => {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    saveContent() {
      // let data = { ...this.dateForm };
      let param = {};
      param = { ...this.dateForm };
      if (!this.editFlag) {
        //新增审核文件
        saveBidOrder(param)
          .then((res) => {
            if (res.code == 10000000) {
              //保存审批流
              this.saveApproveFun(res.data);
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
            this.rLoading.close();
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
            this.rLoading.close();
          });
      } else {
        //更新审核文件
        param.id = this.bidOrderId;
        updateBidOrder(param)
          .then((res) => {
            if (res.code == 10000000) {
              //保存审批流
              this.saveApproveFun(this.bidOrderId);
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
            this.rLoading.close();
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
            this.rLoading.close();
          });
      }
    },

    tempSaveContent() {
      // let data = { ...this.dateForm };
      let param = {};
      if (
        this.dateForm.approveTemplateType &&
        this.approveParams.approveProcessDtoList.length > 0
      ) {
        //撤回状态的合同暂存的时候保存审批流
        if (this.approveParams.approveProcessDtoList.length < 1) {
          this.$alert(" 未选择审批人员", "提示", {
            confirmButtonText: "确定",
          });
          this.rLoading.close()
          return;
          
        }
        for (
          let i = 0;
          i < this.approveParams.approveProcessDtoList.length;
          i++
        ) {
          delete this.approveParams.approveProcessDtoList[i].type;
          if (
            this.approveParams.approveProcessDtoList[i].approveUserId == "" ||
            null == this.approveParams.approveProcessDtoList[i].approveUserId
          ) {
            this.$alert("未选择审批人员", "提示", {
              confirmButtonText: "确定",
            });
            this.rLoading.close()
            return;
          }
        }
      }
      param = { ...this.dateForm };
      if (!this.editFlag) {
        //新增审核文件
        saveBidOrder(param)
          .then(async (res) => {
            if (res.code == 10000000) {
              //保存审批流
              if (
                this.dateForm.approveTemplateType &&
                this.approveParams.approveProcessDtoList.length > 0
              ) {
                await this.saveTempApproveFun(res.data);
              } else {
                this.$message.success("暂存成功");
              }
              this.rLoading.close()
              this.bus.$emit("tabClose", "bidOrderAdd");
              this.bus.$emit("navMenuChange", {
                routeId: "bidOrder",
              });

              this.clearDialogForm();
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
            this.rLoading.close()
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
            this.rLoading.close()
          });
      } else {
        //更新审核文件
        param.id = this.bidOrderId;
        updateBidOrder(param)
          .then(async (res) => {
            if (res.code == 10000000) {
              // this.$message.success("暂存成功");
              //保存审批流
              if (
                this.dateForm.approveTemplateType &&
                this.approveParams.approveProcessDtoList.length > 0
              ) {
                await this.saveTempApproveFun(this.bidOrderId);
              } else {
                this.$message.success("暂存成功");
              }

              this.bus.$emit("tabClose", "bidOrderEdit");
              this.bus.$emit("navMenuChange", {
                routeId: "bidOrder",
              });
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },

    //创建审批流函数
    async saveApproveFun(id) {
      this.approveParams.itemId = id;
      this.approveParams.projectId = this.dateForm.projectId ?? 0;
      this.approveParams.approveStatusEnum = "UNDERAPLLY"; //只是先保存，传READY；若审批流直接开始，传UNDERAPLLY
      this.approveParams.approveClass = "BID_JOIN_SIGNATURE";
      let subType = "联签单";
      this.approveParams.itemName = `${this.dateForm.applyUserName}关于项目 ${this.dateForm.projectName} 采购计划编号为 ${this.dateForm.bidPlanCode} 的 ${subType}申请`;
      let apiName=this.flag?updateApproveFun:saveApproveFun
      let res = await apiName(this.approveParams);
      this.rLoading.close();
      if (res.code == 10000000) {
        if (!this.editFlag) {
          this.$message.success("保存成功");
          this.bus.$emit("tabClose", "bidOrderAdd");
          this.clearDialogForm();
        } else {
          this.$message.success("提交成功");
          this.bus.$emit("tabClose", "bidOrderEdit");
        }
        this.bus.$emit("navMenuChange", {
          routeId: "bidOrder",
        });
      } else {
        this.$message.error(res.msg);
      }
    },
    //暂存保存审批流
    async saveTempApproveFun(id) {
      for (
          let i = 0;
          i < this.approveParams.approveProcessDtoList.length;
          i++
        ) {
          delete this.approveParams.approveProcessDtoList[i].type;
          if (
            this.approveParams.approveProcessDtoList[i].approveUserId == "" ||
            null == this.approveParams.approveProcessDtoList[i].approveUserId
          ) {
            this.$alert("未选择审批人员", "提示", {
              confirmButtonText: "确定",
            });
            this.rLoading.close()
            return;
          }
        }
      this.approveParams.itemId = id;
      this.approveParams.projectId = this.dateForm.projectId ?? 0;
      this.approveParams.approveStatusEnum = "READY"; //只是先保存，传READY；若审批流直接开始，传UNDERAPLLY
      this.approveParams.approveClass = "BID_JOIN_SIGNATURE";
      let subType = "联签单";
      this.approveParams.itemName = `${this.dateForm.applyUserName}关于项目 ${this.dateForm.projectName} 采购计划编号为 ${this.dateForm.bidPlanCode} 的 ${subType}申请`;
      let res = await saveApproveFun(this.approveParams);
      this.rLoading.close();
      if (res.code == 10000000) {
        this.$message.success("暂存成功");
      } else {
        this.$message.error(res.msg);
      }
    },
    clearDialogForm() {
      this.dateForm = {
        id: 0,
        bidPlanId: "", //采购计划编号
        projectId: "", //项目名称
        commitDeptName: "", //提报部门
        commitDeptId: "", //提报部门
        projectState: "", //项目概况
        bidPlanItem: "", //采购文件事项
        attachmentList: [], //采购文件附件
        projectType: "", //项目类别
        bidPlanMethodKey: "", //采购方式字典key
        bidPlanMethodValue: "", //
        isDecisionBase: "0",
        estimatePrice: "", //采购金额
        status: "", //是否暂存标识 0：暂存，2：提交
        remark: "", //备注
        approveTemplateType: "controlprice",
        approveTemplateName: "控制价审核",
      };
    },
    close() {
      let that = this;
      if (!this.editFlag) {
        this.bus.$emit("tabClose", "bidOrderAdd");
      } else {
        this.bus.$emit("tabClose", "bidOrderEdit");
      }
      this.bus.$emit("navMenuChange", {
        routeId: "bidOrder",
      });

      this.clearDialogForm();
    },
    //获取一条信息
    getDetail(id) {
      let param = {};
      param.bidSignatureId = id;
      getBidOrderdetail(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.dateForm = { ...this.dateForm, ...res.data };
            this.dateForm.isDecisionBase =  this.dateForm.isDecisionBase.toString();
            this.dateForm.attachmentList = res.data.attachmentList ?? [];
            this.getProjectSubClass();
            this.getbidPlanCodes();
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },

    //根据项目获取采购计划编号下拉框数据
    getbidPlanCodes() {
      let reqParam = {
        approveType: "bidSignature",
        projectId: this.dateForm.projectId,
        bidPlanItem: encodeURIComponent(this.dateForm.bidPlanItem),
      };
      getBidPlanNos(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            this.bidPlanCodeList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert(err, "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    //根据采购文件事项
    getProjectSubClass() {
      let reqParam = {
        approveType: "bidSignature",
        projectId: this.dateForm.projectId,
      };
      getSubProjects(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            this.projectsubList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert(err, "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },

     //根据项目获取项目部名称
     getAllProject() {
      getAllProjectPassListService()
        .then((res) => {
          if (res.code == "10000000") {
            let projects= res.data
            let index =projects.findIndex(
              (item) => item.id === this.dateForm.projectId
            );
            if (index !== -1) {
              this.dateForm.commitDeptName = projects[index].deptName;
              this.dateForm.commitDeptId =  projects[index].deptId;
            }
          }
        })
        .catch(() => {});
    },

    closeDialog() {
      this.applyUserDiaVisible = false;
    },

    //存储附件
    saveUpdateFile(selectItems) {
      this.dateForm.attachmentList = selectItems;
    },
    //存储审批流模板类型
    saveApproveType(item) {
      this.dateForm.approveTemplateType = item.label;
      this.dateForm.approveTemplateName = item.value;
    },
    //存储审批流
    saveApproveLine(selectItems,flag=false) {
      this.flag=flag
      this.approveParams.approveProcessDtoList = selectItems;
    },
    //提报部门
    selectAttendDepart() {
      // 选择参会部门
      this.selectDialogOptions = {
        departOn: true,
        groupOn: false,
        canSelectDepart: true,
        canSelectUser: false,
        canSelectGroup: false,
        maxSelectedItem: 1,
        dataKey: "attendDepart",
      };
      this.selectDialogVisible = true;
    },
    selectDialogClose(data) {
      this.selectDialogVisible = false;
      const { dataKey } = data;
      switch (dataKey) {
        case "attendDepart": // 参会部门
          this.dateForm.commitDeptName = data.departList[0].name;
          this.dateForm.commitDeptId = data.departList[0].id;
          break;
        case "commitResponseUserName": // 提报单位负责人
          if (data.userList && data.userList.length > 0) {
            let item = data.userList[0];
            this.dateForm.commitResponseUserName =
              item.displayName || item.name;
            this.dateForm.commitResponseUserId = item.id;
          }
          break;
        case "handlingUserName": // 经办人
          if (data.userList && data.userList.length > 0) {
            let item = data.userList[0];
            this.dateForm.handlingUserName = item.displayName || item.name;
            this.dateForm.handlingUserId = item.id;
          }
          break;
        default:
          break;
      }
    },
    //提报单位负责人
    selectSubmitPerson(type) {
      this.selectDialogOptions = {
        departOn: true,
        groupOn: true,
        canSelectDepart: false,
        canSelectUser: true,
        canSelectGroup: false,
        maxSelectedItem: 1,
        dataKey: type,
        canSelectAll: false,
      };
      this.selectDialogVisible = true;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";

.addbidOrder {
  background-color: white;
  height: 100%;
  overflow: hidden;

  .tabWrap {
    height: calc(100% - 60px);
    // /deep/.el-tabs__item.is-top.is-active {
    //   background-color: #ffffff;
    // }

    /deep/ .el-tabs--top {
      height: 100%;
      overflow: hidden;

      .el-tabs__content {
        height: calc(100% - 40px);
        padding: 0 20px;
        // margin-top: 20px;
        overflow: auto;

        .el-form-item {
          width: 100%;
        }

        .el-checkbox {
          line-height: 40px;
        }

        .el-textarea {
          min-width: 0px !important;
        }

        .el-form-item__content {
          width: calc(100% - 150px);

          .el-input {
            width: 100%;
          }
        }
      }
    }
    .Contractfile {
      height: 44px;
      // padding-left: 24px;
      margin-bottom: 24px;
      box-shadow: 0px 1px 0px 0px rgba(238, 238, 238, 1);
      border-radius: 2px 2px 0px 0px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      line-height: 44px;
      text-align: left;
    }
  }

  .bottomBtn {
    // border-top: 1px solid #e6e6e6;
    width: 60%;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
}

/deep/ .el-cascader .el-input__inner {
  &::placeholder {
    color: #606266;
  }

  &::-webkit-input-placeholder {
    /* WebKit browsers 适配谷歌 */
    color: #606266;
  }
}

/*.el-container {*/
/*    width: 100%;*/
/*    overflow: hidden;*/
/*}*/

.approve-rule {
  color: red;
  /* text-align: right; */
  position: absolute;
  right: 30px;
  top: 20px;
  height: 40px;
  display: flex;
  align-items: center;
  z-index: 1;
}

/deep/ .el-header {
  position: relative;
}

/deep/ .el-tabs__item {
  padding: 0 20px !important;
}

/deep/ .el-tabs__header {
  padding-right: 0px !important;
}

.screenPanel {
  text-align: left;
  height: auto;
}

.operatePanel {
  text-align: left;
  margin: 20px 60px;
}

.el-select {
  width: 100%;
}
.el-cascader {
  width: 100%;
}
.btnList {
  text-align: center;
  margin-top: 20px;
}

.el-form-item {
  margin-bottom: 14px;
}

.time-box {
  //  display: flex;
  // height: 180px;
  overflow-y: auto;
  flex: 1;

  .item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
  }
}

.left {
  width: 320px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 10px;
}

.right {
  height: 32px;
  line-height: 32px;
  width: 60px;
  text-align: center;
  cursor: pointer;
}

.add {
  background-color: #00cccc;
  border-radius: 2px;
  color: #ecf5ff;
}

.el-select {
  margin-right: 10px;
}

/deep/ .el-date-editor--time {
  width: 130px;
}

/deep/ .el-container .el-main {
  height: auto;
}
.firstTab {
  width: 72%;
  margin-top: 20px;
}
.firstTab1 {
  width: 100%;
  margin-top: 20px;
}
@media only screen and(max-width:1610px) {
  .firstTab {
    width: 90%;
    margin-top: 20px;
  }
  .firstTab1 {
    width: 100%;
    margin-top: 20px;
  }
}
</style>

<style scoped>
.hidden >>> .el-upload--picture-card {
  display: none;
}
</style>
